import LandingPage from "@/pages/portal/LandingPage.vue";
import APMembershipOptions from "@/pages/portal/APMembershipOptions.vue";
import ClassSignup from "@/pages/portal/ClassSignup.vue";
import PortalCheckout from "@/pages/portal/PortalCheckout.vue";
import NotFound from "@/pages/NotFound.vue";
import LoginPage from "@/pages/LoginPage.vue";
import ChangePasswordPage from "@/pages/ChangePasswordPage.vue";
import DonationPurposes from "@/pages/portal/DonationPurposes.vue";
import PersonProfile from "@/pages/portal/PersonProfile.vue";
import ManageChildren from "@/pages/portal/ManageChildren.vue";
import JPMembershipOptions from "@/pages/portal/JPMembershipOptions.vue";
import UAPMembershipOptions from "@/pages/portal/UAPMembershipOptions.vue";
import PortalCart from "@/pages/portal/PortalCart.vue";
import Donate from "@/pages/portal/Donate.vue";
import OrderConfirmation from "@/pages/portal/OrderConfirmation.vue";
import ScholarshipApplication from "@/pages/portal/ScholarshipApplication.vue";
import PersonRegistrationStandalone from "@/pages/portal/PersonRegistrationStandalone.vue";
import PersonCard from "@/pages/portal/PersonCard.vue";
import GiftCard from "@/pages/portal/GiftCard.vue";
import OptOut from "@/pages/portal/OptOut.vue";
import ManageOptOuts from "@/pages/portal/ManageOptOuts.vue";
import ClassWaitlistAccept from "@/pages/portal/ClassWaitlistAccept.vue";

export const routesMode = [
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFound,
    meta: {
      layout: "PortalLayout",
      requiresAuth: false,
    },
  },
  {
    path: "/",
    name: "home",
    component: LandingPage,
    meta: {
      layout: "PortalLayout",
      requiresAuth: false,
    },
  },
  {
    path: "/login",
    name: "login",
    component: LoginPage,
    meta: {
      layout: "PortalLayout",
      requiresAuth: false,
    },
  },
  {
    path: "/reset-password",
    name: "reset password",
    component: ChangePasswordPage,
    meta: {
      layout: "PortalLayout",
      requiresAuth: false,
    },
  },
  {
    path: "/cart",
    name: "portal-cart",
    component: PortalCart,
    meta: {
      layout: "PortalLayoutShopless",
      requiresAuth: false,
    },
  },
  {
    path: "/checkout",
    name: "portal-checkout",
    component: PortalCheckout,
    meta: {
      layout: "PortalLayoutShopless",
      requiresAuth: false,
    },
  },
  {
    path: "/order/:id",
    name: "order-confirmation",
    component: OrderConfirmation,
    meta: {
      layout: "PortalLayout",
    },
  },
  {
    path: "/profile/:personId?",
    name: "Person Profile",
    component: PersonProfile,
    meta: {
      layout: "PortalLayout",
      requiresAccount: true,
    },
  },
  {
    path: "/adult-memberships",
    name: "adult-memberships",
    component: APMembershipOptions,
    meta: {
      layout: "PortalLayout",
      requiresAuth: false,
    },
  },
  {
    path: "/youth-memberships/:id?",
    name: "youth-memberships",
    component: JPMembershipOptions,
    meta: {
      layout: "PortalLayout",
      requiresAuth: false,
    },
  },
  {
    path: "/accessible-memberships",
    name: "Accessible Memberships",
    component: UAPMembershipOptions,
    meta: {
      layout: "PortalLayout",
      requiresAuth: false,
    },
  },
  {
    path: "/donation-purposes",
    name: "donation purposes",
    component: DonationPurposes,
    meta: {
      layout: "PortalLayout",
      requiresAuth: false,
    },
  },
  {
    path: "/donate",
    name: "donate",
    component: Donate,
    meta: {
      layout: "PortalLayout",
      requiresAuth: false,
    },
  },
  {
    path: "/gift-certificate",
    name: "Gift Certificates",
    component: GiftCard,
    meta: {
      layout: "PortalLayout",
      requiresAuth: false,
    },
  },
  {
    path: "/class-signup",
    name: "Class Signup",
    component: ClassSignup,
    meta: {
      layout: "PortalLayout",
      requiresAuth: false,
    },
  },
  {
    path: "/manage-children",
    name: "Manage Children",
    component: ManageChildren,
    meta: {
      layout: "PortalLayout",
    },
  },
  {
    path: "/scholarship",
    name: "Scholarship",
    component: ScholarshipApplication,
    meta: {
      layout: "PortalLayout",
    },
  },
  {
    path: "/registration",
    name: "registration",
    component: PersonRegistrationStandalone,
    meta: {
      layout: "KioskLayout",
      requiresAuth: false,
    },
  },
  {
    path: "/card/:number",
    name: "Person Card",
    component: PersonCard,
    meta: {
      layout: "CardLayout",
      requiresAuth: true,
    },
  },
  {
    path: "/opt-out",
    name: "Opt Out",
    component: OptOut,
    meta: {
      layout: "PortalLayout",
      requiresAuth: false,
    },
  },
  {
    path: "/manage-opt-outs",
    name: "Manage Opt Outs",
    component: ManageOptOuts,
    meta: {
      layout: "PortalLayout",
      requiresAuth: true,
    },
  },
  {
    path: "/class-waitlist-accept",
    name: "Class Waitlist Accept",
    component: ClassWaitlistAccept,
    meta: {
      layout: "PortalLayout",
      requiresAuth: true,
    },
  },
];
